/* SplashStrong: animaciones + confianza y promos en carrito lateral */
(function () {
  var root = document.documentElement;
  root.classList.add('ss-js');
  if (window.Shopify && window.Shopify.designMode) root.classList.add('ss-design');

  var io = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 })
    : null;

  function scan(scope) {
    (scope || document).querySelectorAll('.ss-reveal:not(.is-in)').forEach(function (el) {
      if (io) io.observe(el); else el.classList.add('is-in');
    });
  }

  function bar(cls, done, count, icon, txt, pct, mark) {
    return '<div class="ss-promo-progress' + cls + (done ? ' is-done' : '') + '" data-count="' + count + '"><p class="ss-promo-progress__text"><span class="ss-promo-progress__gift" aria-hidden="true">' + icon + '</span><span>' + txt + '</span></p><div class="ss-promo-progress__bar" aria-hidden="true"><span style="width:' + pct + '%"></span>' + (mark ? '<i style="left:60%"></i>' : '') + '</div></div>';
  }

  /* Poleras: lleva 3 = 15% OFF, lleva 5 = 30% OFF. Digitales: Compra 2 y lleva 3. Misma lógica que snippets/ss-promo-progress.liquid */
  function promoHTML(cart) {
    var pol = 0, dig = 0, html = '';
    (cart.items || []).forEach(function (it) {
      if (it.product_type === 'Polera Estampada') pol += it.quantity;
      else if (it.requires_shipping === false) dig += it.quantity;
    });
    if (pol > 0 || dig === 0) {
      var t;
      if (pol === 0) t = '<strong>Lleva 3 poleras y ahorra 15%</strong> · lleva 5 y ahorra 30%.';
      else if (pol < 3) { var f3 = 3 - pol; t = 'Agrega <strong>' + f3 + (f3 === 1 ? ' polera más' : ' poleras más') + '</strong> y ahorra <strong>15%</strong>.'; }
      else if (pol < 5) { var f5 = 5 - pol; t = '<strong>¡15% OFF aplicado!</strong> Suma ' + f5 + (f5 === 1 ? ' polera más' : ' poleras más') + ' y sube a <strong>30%</strong>.'; }
      else t = '<strong>¡30% OFF aplicado!</strong> Tienes el máximo descuento en tus poleras.';
      html += bar(' ss-promo-progress--tiers', pol >= 5, pol, '👕', t, Math.min(100, Math.round(pol * 100 / 5)), true);
    }
    if (dig > 0) {
      var r = dig % 3, gratis = Math.floor(dig / 3), faltan = 3 - r, done = r === 0;
      var d = done
        ? '<strong>¡Listo!</strong> Tienes ' + gratis + (gratis === 1 ? ' diseño digital gratis.' : ' diseños digitales gratis.')
        : 'Digitales: agrega <strong>' + faltan + (faltan === 1 ? ' diseño más' : ' diseños más') + '</strong> y el 3º es <strong>GRATIS</strong>.';
      html += bar('', done, dig, '🎁', d, done ? 100 : Math.round(r * 100 / 3), false);
    }
    return '<div class="ss-promo-stack">' + html + '</div>';
  }

  var busy = false;
  function updateDrawerPromo(force) {
    var footer = document.querySelector('#CartDrawer .drawer__footer');
    if (!footer || busy) return;
    var existing = footer.querySelector('.ss-promo-stack');
    if (existing && !force) return;
    busy = true;
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var f = document.querySelector('#CartDrawer .drawer__footer');
        if (!f) return;
        var old = f.querySelector('.ss-promo-stack');
        if (old) old.remove();
        f.insertAdjacentHTML('afterbegin', promoHTML(cart));
      })
      .catch(function () {})
      .then(function () { busy = false; });
  }

  function injectTrust() {
    var footer = document.querySelector('#CartDrawer .drawer__footer');
    var tpl = document.getElementById('ss-drawer-trust');
    if (footer && tpl && !footer.querySelector('.ss-trust')) footer.appendChild(tpl.content.cloneNode(true));
    if (footer && !footer.querySelector('.ss-promo-stack')) updateDrawerPromo(true);
  }

  function init() {
    scan();
    injectTrust();
    var drawer = document.querySelector('cart-drawer');
    if (drawer && 'MutationObserver' in window) new MutationObserver(injectTrust).observe(drawer, { childList: true, subtree: true });
    document.addEventListener('cart:updated', function () { updateDrawerPromo(true); });
    if (window.subscribe && window.PUB_SUB_EVENTS) {
      try { subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(function () { updateDrawerPromo(true); }, 150); }); } catch (e) {}
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  setTimeout(function () { document.querySelectorAll('.ss-reveal:not(.is-in)').forEach(function (el) {
    var r = el.getBoundingClientRect(); if (r.top < window.innerHeight) el.classList.add('is-in');
  }); }, 2500);
})();
